import React from 'react';
import { makeStyles, TableRow } from '@material-ui/core';
import classnames from 'classnames';
import { Field, change } from 'redux-form';
import Fields from 'components/Fields';
import { FieldCurrency, FieldPercent } from 'components/Base';
import Store from 'store/store';
import TableComponents from 'components/Table';
import {
  formatCurrency,
  formatPercent,
  unFormatCurrency,
  unFormatPercent
} from 'utils';

const { connect } = Store;

const useStyles = makeStyles({
  checkbox: {
    paddingRight: 0
  },
  chargeRow: {
    border: 0
  },
  totalRow: {
    height: '60px',
    marginTop: '5px',
    padding: '1rem 0',
    backgroundColor: '#fff !important',
    borderTop: '1px solid #eaeaea',
    '& span ': {
      fontWeight: '600',
      color: '#0080bd'
    }
  }
});

interface ChargeProps {
  charge: string;
  chargeValues: any;
  allowPercentage: boolean;
  changeField: any;
  formName: string;
  totalFundValue: string;
}

const Charge = ({
  charge,
  chargeValues,
  changeField,
  formName,
  totalFundValue
}: ChargeProps) => {
  const classes = useStyles();
  const readOnlyFieldsKinds = [1, 2, 98, 8, 13];
  const isReadOnly = readOnlyFieldsKinds.includes(chargeValues.kind);
  const isRowForTotalValue = chargeValues.name === 'Total';
  const shouldValidateField = !readOnlyFieldsKinds.includes(chargeValues.kind);
  const isBolded = chargeValues.kind === 98;

  return (
    <>
      <TableRow
        className={classnames(
          classes.chargeRow,
          isRowForTotalValue && classes.totalRow
        )}
      >
        <TableComponents.TableCell
          style={{ fontWeight: isBolded ? '700' : '500' }}
        >
          <Field
            name={`${charge}.name`}
            fullWidth
            component={Fields.String}
            disabled
            readOnly
          />
        </TableComponents.TableCell>
        <TableComponents.TableCell
          style={{ width: '100px', fontWeight: isBolded ? '700' : '500' }}
        >
          <FieldPercent
            name={`${charge}.percentage_value`}
            fullWidth
            id={`${chargeValues.kind}-percentage_value`}
            clearfieldinform={formName}
            onChange={(event: any) => {
              changeField(
                formName,
                `${charge}.cash_value`,
                formatCurrency(
                  parseFloat(unFormatCurrency(totalFundValue)) *
                    Number(unFormatPercent(event.target.value) / 100)
                )
              );
              changeField(formName, `${charge}.source_value`, 2);
            }}
            validate={
              shouldValidateField
                ? Fields.Validators.isChargePercentageValid
                : undefined
            }
            component={isReadOnly ? Fields.String : Fields.Text}
          />
        </TableComponents.TableCell>
        <TableComponents.TableCell
          style={{ width: '120px', fontWeight: isBolded ? '700' : '500' }}
        >
          <FieldCurrency
            name={`${charge}.cash_value`}
            fullWidth
            id={`${chargeValues.kind}-cash_value`}
            clearfieldinform={formName}
            onChange={(event: any) => {
              changeField(
                formName,
                `${charge}.percentage_value`,
                formatPercent(
                  (Number(unFormatCurrency(event.target.value)) /
                    Number(totalFundValue)) *
                    100
                )
              );
              changeField(formName, `${charge}.source_value`, 1);
            }}
            validate={
              shouldValidateField
                ? Fields.Validators.isChargeExceedMaxChargeValue(
                    Number(totalFundValue)
                  )
                : undefined
            }
            component={isReadOnly ? Fields.String : Fields.Text}
          />
        </TableComponents.TableCell>
      </TableRow>
    </>
  );
};

export default connect(null, { changeField: change })(Charge);
